import { ShopOnboardingID } from '@prisma/client';
import { useMutation } from '@tanstack/react-query';
import { completeOnboardingStep } from '../../services/business';
import { CompleteOnboardingStepResponse } from '../../types/businesses';
import useUser from '../global/useUser';
import useGetOnboarding from './useGetOnboarding';

interface Options {
  onSuccess?: (
    result: CompleteOnboardingStepResponse | null,
  ) => void | Promise<void>;
  onError?: () => void | Promise<void>;
}

function useCompleteOnboardingStep({ onSuccess, onError }: Options = {}) {
  const { isEnabled, completedSteps, reloadAfterUpdate } = useGetOnboarding();
  const { user } = useUser();

  return useMutation({
    mutationFn: async (stepId: ShopOnboardingID) => {
      if (!user?.business?.id || !isEnabled) return null;
      const isStepCompleted = completedSteps?.some(
        completedStep => completedStep.id === stepId,
      );
      if (isStepCompleted) return null;
      const result = await completeOnboardingStep(user.business.id, stepId);
      return result;
    },
    onSuccess: async result => {
      if (!result) return;
      await reloadAfterUpdate(result.stepId);
      await onSuccess?.(result);
    },
    onError,
  });
}

export default useCompleteOnboardingStep;
